import { ActionButtonVariant } from '@/share/model/dialog.types';

const VARIANT_CLASSES: Record<ActionButtonVariant, string> = {
    primary: 'bg-indigo-600 text-white shadow-md shadow-indigo-300/50 hover:bg-indigo-700 focus:ring-indigo-400 ',
    secondary: 'bg-white border border-slate-200 text-slate-500 shadow-sm hover:bg-slate-50 hover:text-slate-700 focus:ring-slate-300 ',
    danger: 'bg-red-500 text-white shadow-md shadow-red-300/40 hover:bg-red-600 focus:ring-red-400 ',
    warning: 'bg-amber-400 text-white shadow-md shadow-amber-300/40 hover:bg-amber-500 focus:ring-amber-400 ',
    ghost: 'bg-white/70 border border-slate-200 text-slate-400 hover:bg-slate-100 hover:text-slate-600 focus:ring-slate-200 '
};

export interface ActionButtonClassOptions {
    variant?: ActionButtonVariant;
    disabled?: boolean;
    loading?: boolean;
    showLabel?: boolean;
    /** dynamic-dialog toggles cursor-pointer/cursor-not-allowed via the disabled state;
     *  action-detail-dialog bakes cursor-pointer into the base and only adds
     *  pointer-events-none when disabled. Defaults to the dynamic-dialog behavior. */
    cursorStyle?: 'toggle' | 'pointer-events-none';
}

/** OCP: single source of truth for action-button Tailwind classes across dialog components. */
export function actionButtonClass(options: ActionButtonClassOptions): string {
    const {
        variant = 'secondary',
        disabled = false,
        loading = false,
        showLabel = false,
        cursorStyle = 'toggle',
    } = options;

    const isMuted = disabled || loading;
    const base = cursorStyle === 'pointer-events-none'
        ? 'cursor-pointer flex items-center transition-all duration-150 active:scale-95 focus:outline-none focus:ring-2 focus:ring-offset-1 '
        : 'flex items-center transition-all duration-150 active:scale-95 focus:outline-none focus:ring-2 focus:ring-offset-1 ';
    const size = showLabel ? 'p-3 rounded-xl justify-start ' : 'p-3 rounded-xl justify-center ';
    const state = cursorStyle === 'pointer-events-none'
        ? (isMuted ? 'opacity-50 cursor-not-allowed pointer-events-none ' : '')
        : (isMuted ? 'opacity-50 cursor-not-allowed ' : 'cursor-pointer ');

    return base + size + state + VARIANT_CLASSES[variant];
}
